import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { asset } from "../../lib/api";
import { GROUPS, STATUS, say } from "../../lib/zhuyinRoom";
import { GlyphOverlay } from "./Strokes";

export const RoomShell = ({ title, back = "/zhuyin", right, children, testid }) => {
  const nav = useNavigate();
  return (
    <div className="min-h-screen paper-bg flex flex-col" data-testid={testid}>
      <header className="sticky top-0 z-20 flex items-center gap-3 px-4 sm:px-8 py-3 bg-[#E3F2FB]/90 backdrop-blur-md border-b-2 border-[#b9dcf0]">
        <button data-testid="room-back-btn" onClick={() => nav(back)} className="w-14 h-14 rounded-full bg-white border-2 border-[#b9dcf0] text-[#1D6FB8] flex items-center justify-center shrink-0"><ArrowLeft size={26} /></button>
        <h1 className="font-serif-tc text-2xl sm:text-3xl font-black text-[#14507f]" data-testid="room-title">{title}</h1>
        <div className="ml-auto flex items-center gap-2">{right}</div>
      </header>
      <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-8 py-6">{children}</main>
    </div>
  );
};

export const groupOf = (z) => GROUPS.find((g) => g.key === z.category) || GROUPS[2];

export const ZhuyinCard = ({ z, onClick, overlay = true, className = "", testid }) => (
  <motion.button whileTap={{ scale: 0.97 }} onClick={onClick || (() => say(z))} data-testid={testid}
    className={`rounded-[2rem] bg-[#BFE3F5] border-[6px] border-white shadow-xl overflow-hidden flex flex-col text-left ${className}`}>
    <div className="relative aspect-square w-full">
      <img src={asset(z.card_image)} alt={z.mnemonic} className="absolute inset-0 w-full h-full object-cover" />
      {overlay && z.strokes?.length > 0 && <GlyphOverlay strokes={z.strokes} className="absolute inset-[8%] w-[84%] h-[84%]" />}
    </div>
    <div className="mx-3 my-3 rounded-full bg-white px-4 py-2 text-center font-round text-2xl text-stone-800 tracking-widest" data-testid="card-mnemonic">{z.mnemonic}</div>
  </motion.button>
);

export const MiniCard = ({ z, onClick, testid }) => {
  const g = groupOf(z);
  return (
    <motion.button whileHover={{ y: -4 }} whileTap={{ scale: 0.94 }} onClick={onClick} data-testid={testid}
      className="relative rounded-2xl bg-[#BFE3F5] border-4 border-white shadow-md overflow-hidden aspect-[4/5] flex flex-col">
      <img src={asset(z.card_image)} alt="" className="w-full h-[62%] object-cover" />
      <div className="flex-1 flex items-center justify-center bg-white text-4xl sm:text-5xl font-black" style={{ color: g.color }}>{z.symbol}</div>
      <span className="absolute top-2 right-2 w-4 h-4 rounded-full border-2 border-white" style={{ background: STATUS[z.status]?.color }} title={STATUS[z.status]?.label} />
    </motion.button>
  );
};

export const Grouped = ({ cards, render }) => (
  <div className="space-y-8">
    {GROUPS.map((g) => {
      const list = cards.filter((z) => z.category === g.key);
      return (
        <section key={g.key} data-testid={`room-group-${g.key}`}>
          <div className="flex items-baseline gap-3 mb-3">
            <span className="px-4 py-1 rounded-full text-white font-serif-tc text-xl font-black" style={{ background: g.color }}>{g.name}</span>
            <span className="text-stone-500 font-round">{list.length} 個</span>
          </div>
          {render(list, g)}
        </section>
      );
    })}
  </div>
);
